import { Children, createElement, useRef, useState, useEffect, Fragment } from 'react';
import { createStyled } from '@stitches/react';
import ReactHtmlParser from 'react-html-parser';

var _createStyled = /*#__PURE__*/createStyled({
  prefix: 'OneTm'
}),
    css = _createStyled.css;

var styles = {
  wrapper: {
    position: 'relative',
    WebkitBoxSizing: 'border-box',
    boxSizing: 'border-box',
    zIndex: 1,
    'div:first-of-type': {
      marginTop: 0
    },
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 700
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 700
    },
    h4: {
      fontSize: '1.25rem',
      fontWeight: 700
    },
    h5: {
      fontSize: '1rem',
      fontWeight: 700
    },
    h6: {
      fontSize: '0.875rem',
      fontWeight: 700
    }
  },
  block: {
    position: 'relative',
    paddingTop: 16,
    paddingBottom: 16,
    padding: '.4em 0',
    margin: '0 auto',
    maxWidth: 650
  }
};
function EditorRenderer(_ref) {
  var blocks = _ref.blocks,
      blockMap = _ref.blockMap,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? '720px' : _ref$maxWidth;

  if (!Array.isArray(blocks)) {
    return null;
  }

  var content = Children.toArray(blocks.map(function (block) {
    var Renderer = blockMap[block.type];

    if (!Renderer) {
      return null;
    }

    if (typeof block.data !== 'object') {
      return null;
    }

    var hasStretched = 'stretched' in block.data && !!block.data.stretched;
    return createElement("div", {
      style: {
        maxWidth: hasStretched ? 'none' : maxWidth
      },
      className: css(styles.block)
    }, createElement(Renderer, {
      data: block.data
    }));
  }));
  return createElement("div", {
    className: css(styles.wrapper)
  }, content);
}

var styles$1 = /*#__PURE__*/css({
  lineHeight: '1.6em',
  width: '100%',
  textAlign: 'center',
  '::before': {
    display: 'inline-block',
    content: "'***'",
    fontSize: '30px',
    lineHeight: '65px',
    height: '30px',
    letterSpacing: '0.2em'
  }
});
var DelimiterRenderer = function DelimiterRenderer() {
  return createElement("div", {
    role: "divider",
    className: styles$1
  });
};

// @ts-ignore
var iframeCss = /*#__PURE__*/css({
  width: '100%'
});
var styles$2 = {
  wrapper: /*#__PURE__*/css({
    display: 'block',
    padding: 25,
    background: '#fff',
    border: '1px solid rgba(201, 201, 204, 0.48)',
    boxShadow: '0 1px 3px rgba(0,0,0, .1)',
    borderRadius: 6,
    textDecoration: 'none'
  }),
  image: /*#__PURE__*/css({
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    margin: '0 0 0 30px',
    width: 65,
    height: 65,
    borderRadius: 3,
    "float": 'right'
  }),
  title: /*#__PURE__*/css({
    fontSize: 17,
    fontWeight: 600,
    lineHeight: '1.5em',
    margin: '0 0 10px 0',
    color: 'initial'
  }),
  desc: /*#__PURE__*/css({
    margin: '0 0 20px 0',
    fontSize: 15,
    lineHeight: '1.55em',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    color: 'initial'
  }),
  anchor: /*#__PURE__*/css({
    display: 'block',
    fontSize: 15,
    lineHeight: '1em',
    color: '#888 !important',
    border: '0 !important',
    padding: '0 !important'
  })
};

function isNonEmptyObject(obj) {
  if (!obj) {
    return false;
  }

  return !(Object.keys(obj).length === 0 && obj.constructor === Object);
}

var EmbedLinkRenderer = function EmbedLinkRenderer(_ref) {
  var data = _ref.data;

  if (isNonEmptyObject(data.embed)) {
    return createElement("figure", null, createElement("iframe", {
      className: iframeCss,
      width: data.embed.width,
      height: data.embed.height,
      src: data.embed.embed
    }), data.caption && createElement("figcaption", null, ReactHtmlParser(data.caption)));
  }

  if (isNonEmptyObject(data.meta)) {
    var _data$meta, _data$meta$image;

    var url = data.link;

    try {
      url = new URL(data.link).hostname;
    } catch (error) {
      url = data.link;
    }

    return createElement("a", {
      className: styles$2.wrapper,
      rel: "nofollow noindex noreferrer",
      target: "_blank",
      href: data.link
    }, ((_data$meta = data.meta) == null ? void 0 : (_data$meta$image = _data$meta.image) == null ? void 0 : _data$meta$image.url) && createElement("div", {
      className: styles$2.image,
      style: {
        backgroundImage: "url(" + data.meta.image.url + ")"
      }
    }), createElement("div", {
      className: styles$2.title
    }, data.meta.title), createElement("p", {
      className: styles$2.desc
    }, data.meta.description), createElement("span", {
      className: styles$2.anchor
    }, url));
  }

  return null;
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

// https://github.com/1tmio/editor-gallery/blob/master/src/calc.js
// will start import them after

var maxMediaPerRow = 3;
var minRatio = 9 / 2;
function calcImageRows(imgs) {
  if (!imgs || !imgs.length) {
    return [];
  }

  var readyImgs = imgs.map(function (img, i) {
    return _extends({}, img, {
      pos: i
    });
  });
  var rows = [];

  while (readyImgs.length > 0) {
    rows.push(splitRows(readyImgs));
  }

  return rows;
}

function isFitToRow(imgs) {
  var totalAspectRatio = getTotalAspectRatio(imgs);
  return totalAspectRatio <= minRatio;
} // @ts-ignore


function splitRows(imgs) {
  for (var index = maxMediaPerRow; index > 0; index--) {
    var sliced = imgs.slice(0, index);
    var isFit = isFitToRow(sliced);

    if (isFit || index === 1) {
      imgs.splice(0, index); // side effect

      return sliced;
    }
  }
}

function calcImageWidthPerRow(imgs, totalWidth, gap) {
  if (gap === void 0) {
    gap = 0;
  }

  var totalAspectRatioPerRow = getTotalAspectRatio(imgs);
  var eachGrid = (totalWidth - gap * (imgs.length - 1)) / totalAspectRatioPerRow;

  for (var _iterator = _createForOfIteratorHelperLoose(imgs), _step; !(_step = _iterator()).done;) {
    var img = _step.value;

    if ('width' in img && 'height' in img) {
      img.displayWidth = img.width / img.height * eachGrid;
    }
  }

  return imgs;
}

function getTotalAspectRatio(imgs) {
  var totalAspectRatio = 0;

  for (var _iterator2 = _createForOfIteratorHelperLoose(imgs), _step2; !(_step2 = _iterator2()).done;) {
    var img = _step2.value;
    totalAspectRatio += img.width / img.height;
  }

  return totalAspectRatio;
}

function GalleryRenderer(_ref) {
  var data = _ref.data,
      renderImage = _ref.renderImage;
  var ref = useRef(null);
  var imageRows = calcImageRows(data.files || []);

  var _useState = useState(720),
      width = _useState[0],
      setWidth = _useState[1];

  useEffect(function () {
    // @ts-ignore
    var resizeObserver = new ResizeObserver(function (entries) {
      for (var _iterator3 = _createForOfIteratorHelperLoose(entries), _step3; !(_step3 = _iterator3()).done;) {
        var entry = _step3.value;

        if (entry.contentRect) {
          setWidth(entry.contentRect.width);
        }
      }
    });
    resizeObserver.observe(ref.current);
    return function () {
      resizeObserver && 'unobserve' in resizeObserver && resizeObserver.unobserve(ref.current);
    };
  }, []);
  return createElement("div", {
    ref: ref,
    className: css({
      marginBottom: '24px'
    })
  }, imageRows.map(function (files, i) {
    return createElement("div", {
      className: css({
        display: 'grid',
        gridAutoFlow: 'column',
        marginBottom: 8,
        gap: '8px'
      }),
      key: i
    }, createElement(ImageRow, {
      renderImage: renderImage,
      containerWidth: width,
      data: files || []
    }));
  }));
}

function ImageRow(_ref2) {
  var data = _ref2.data,
      containerWidth = _ref2.containerWidth,
      renderImage = _ref2.renderImage;
  var assets = calcImageWidthPerRow(data, containerWidth, 8);
  return createElement(Fragment, null, assets.map(function (asset, i) {
    return createElement(Fragment, null, renderImage ? renderImage(asset, i) : createElement(AspectRatioImage, {
      key: i,
      data: asset
    }));
  }));
}

function AspectRatioImage(_ref3) {
  var data = _ref3.data;
  var aspectRatio = data.height / data.width;
  return createElement("div", {
    className: css({
      display: 'flex',
      height: 0,
      position: 'relative'
    }),
    style: {
      width: data.displayWidth ? data.displayWidth + 'px' : '100%',
      paddingTop: "calc(" + (Number.isNaN(aspectRatio) ? 0.5 : aspectRatio) + " * 100%)"
    }
  }, createElement("img", {
    src: data.url,
    width: data.displayWidth,
    className: css({
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    })
  }));
}

// @ts-ignore
var headerStyle = {
  padding: '0',
  lineHeight: '1.5em',
  outline: 'none'
};
var HeaderRenderer = function HeaderRenderer(_ref) {
  var data = _ref.data;
  var result = createElement("h4", {
    className: css(headerStyle)
  }, ReactHtmlParser(data.text));

  switch (data.level) {
    case 1:
      result = createElement("h1", {
        className: css(headerStyle)
      }, ReactHtmlParser(data.text));
      break;

    case 2:
      result = createElement("h2", {
        className: css(headerStyle)
      }, ReactHtmlParser(data.text));
      break;

    case 3:
      result = createElement("h3", {
        className: css(headerStyle)
      }, ReactHtmlParser(data.text));
      break;

    case 4:
      result = createElement("h4", {
        className: css(headerStyle)
      }, ReactHtmlParser(data.text));
      break;

    case 5:
      result = createElement("h5", {
        className: css(headerStyle)
      }, ReactHtmlParser(data.text));
      break;

    case 6:
      result = createElement("h6", {
        className: css(headerStyle)
      }, ReactHtmlParser(data.text));
      break;
  }

  return result;
};

var commonListStyle = {
  paddingLeft: 40,
  outline: 'none',
  position: 'relative',
  left: 18
};
var styles$3 = {
  ul: /*#__PURE__*/_extends({
    listStyle: 'disc'
  }, commonListStyle),
  ol: /*#__PURE__*/_extends({
    listStyle: 'decimal'
  }, commonListStyle),
  item: {
    padding: '5.5px 0 5.5px 3px',
    lineHeight: '1.6em'
  }
};
var ListRenderer = function ListRenderer(_ref) {
  var data = _ref.data;
  var listItems = Children.toArray(data.items.map(function (item) {
    return createElement("li", {
      className: css(styles$3.item)
    }, ReactHtmlParser(item));
  }));

  if (data.style === 'ordered') {
    return createElement("ol", {
      className: css(styles$3.ol)
    }, listItems);
  }

  if (data.style === 'unordered') {
    return createElement("ul", {
      className: css(styles$3.ul)
    }, listItems);
  }

  return null;
};

var styles$4 = {
  p: /*#__PURE__*/css({
    lineHeight: '1.6em',
    outline: 'none',
    code: {
      background: 'rgba(250, 239, 240, 0.78)',
      color: '#b44437',
      padding: '3px 4px',
      borderRadius: 5,
      margin: '0 1px',
      fontFamily: 'inherit',
      fontSize: '0.86em',
      fontWeight: 500,
      letterSpacing: 0.3
    },
    mark: {
      background: 'rgba(245,235,111,0.29)',
      padding: '3px 0'
    },
    a: {
      cursor: 'pointer',
      textDecoration: 'underline',
      color: 'inherit'
    }
  })
};
var ParagraphRenderer = function ParagraphRenderer(_ref) {
  var data = _ref.data;
  return createElement("p", {
    className: styles$4.p,
    style: {
      textAlign: data.alignment || 'left'
    }
  }, ReactHtmlParser(data.text));
};

var styles$5 = {
  wrapper: {
    paddingLeft: '24px',
    paddingRight: '24px'
  },
  text: {
    borderTop: 'none',
    borderRight: 'none',
    borderBottom: 'none',
    borderImage: 'initial',
    borderLeft: '2px solid rgb(36, 37, 38)',
    boxShadow: 'none',
    borderRadius: 0,
    marginBottom: 10,
    padding: '10px 12px',
    fontSize: '1rem',
    lineHeight: '20px',
    fontStyle: 'italic',
    color: 'rgb(36, 37, 38)',
    paddingLeft: 16,
    minHeight: 'unset !important'
  }
};
var QuoteRenderer = function QuoteRenderer(_ref) {
  var data = _ref.data;
  return createElement("blockquote", {
    className: css(styles$5.wrapper)
  }, createElement("div", {
    className: css(styles$5.text)
  }, data.text));
};

var BlockMap = {
  paragraph: ParagraphRenderer,
  delimiter: DelimiterRenderer,
  embedLink: EmbedLinkRenderer,
  header: HeaderRenderer,
  list: ListRenderer,
  quote: QuoteRenderer,
  gallery: GalleryRenderer
};

export { AspectRatioImage, BlockMap, DelimiterRenderer, EditorRenderer, EmbedLinkRenderer, GalleryRenderer, HeaderRenderer, ListRenderer, ParagraphRenderer, QuoteRenderer, calcImageRows, calcImageWidthPerRow, headerStyle };
//# sourceMappingURL=editor-renderer.esm.js.map
